import React, { useContext, useTransition } from "react";
import "./CadastrarDominio.scss";
import GlobalContext from "@context/GlobalContext";
import useLoading from "@hooks/useLoading";
import EndPointServices from "@services/ApiServices";
import Button from "@components/button/Button";
import { useForm } from "react-hook-form";
import Input from "@components/input/Input";
import UtilServices from "@services/UtilServices";
import MessageServices from "@services/MessageServices";

const CadastrarDominio = () => {
  const [isPending, startTransition] = useTransition();

  useLoading(isPending);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm({});

  //Variaveis Padrões
  const [state] = useContext(GlobalContext);

  function handleSubmitCadastrar(e) {
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        login_web: e.login_web,
        senha_web: e.senha_web,
        login_dominio: e.login_dominio,
        senha_dominio: e.senha_dominio,
      };

      var retornoapi = await EndPointServices.Cliente_CadastraDominio(data);
      if (retornoapi?.Success) {
        MessageServices.ShowSuccess(
          "Cadastro do certificado realizado com sucesso !",
        );
        reset();
      }
    });
  }

  return (
    <div className="cadastrarcertificado row">
      <form onSubmit={handleSubmit(handleSubmitCadastrar)} className="row mb-4">
        <div className="col-md-3 col-12 mt-2">
          <Input
            title="Login Web (Onvio)"
            placeholder="Login Web (Onvio)"
            setValue={setValue}
            register={register}
            errors={errors}
            registerProps={{
              required: "Login Web é obrigatório",
              validate: {
                sValid: (value) =>
                  UtilServices.validateEmail(value) || "Email inválido.",
              },
            }}
            name="login_web"
            mask="Email"
          />
        </div>
        <div className="col-md-3 col-12 mt-2">
          <Input
            title="Senha Web (Onvio)"
            placeholder="Senha Web (Onvio)"
            type="password"
            setValue={setValue}
            register={register}
            errors={errors}
            registerProps={{
              required: "Senha é obrigatório",
            }}
            name="senha_web"
          />
        </div>
        <div className="col-md-3 col-12 mt-2">
          <Input
            title="Login Dominio"
            placeholder="Login Dominio"
            setValue={setValue}
            register={register}
            errors={errors}
            registerProps={{
              required: "Login Dominio é obrigatório",
            }}
            name="login_dominio"
            mask="Email"
          />
        </div>
        <div className="col-md-3 col-12 mt-2">
          <Input
            title="Senha Dominio"
            placeholder="Senha Dominio"
            type="password"
            setValue={setValue}
            register={register}
            errors={errors}
            registerProps={{
              required: "Senha é obrigatório",
            }}
            name="senha_dominio"
          />
        </div>
        <div className="mt-3">
          <Button
            nome="Cadastrar"
            icon="<i class='fa-solid fa-plus'></i>"
            theme="2"
          />
        </div>
      </form>
    </div>
  );
};

export default CadastrarDominio;
